import React, {
  Component
} from 'react';
import {
  Button,
  Header,
  Icon,
  Label,
  Table
} from 'semantic-ui-react';

const HEADER_CONTENT = 0;
const HEADER_SUBHEADER = 1;

const RecordTable = ({ records, headers, loading, selectRecord, removeRecord }) => {
  if (loading) {
    return (
      <Header as="h2" textAlign="center" icon>
        <Icon name="cloud" />
      </Header>
    );
  } else if (!records || records.length === 0) {
    return (
      <Header as="h2" textAlign="center" icon>
        <Icon name="frown" />
        Tabla Vacia
        <Header.Subheader>
          No hay elementos
        </Header.Subheader>
      </Header>
    );
  } else {
    return (
      <Table basic="very" celled compact size="small" striped >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            {
              Object.keys(headers).map((header, index) => {
                return (
                  <Table.HeaderCell key={index}>{header}</Table.HeaderCell>
                );
              })
            }
            <Table.HeaderCell />
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {
            records.map((record, i) => {
              return (
                <Table.Row key={i}>
                  <Table.Cell collapsing>
                    <Button
                      style={{ margin: 0 }} icon="edit" fluid primary size="mini"
                      onClick={selectRecord.bind(null, record)} />
                  </Table.Cell>
                  {
                    Object.keys(headers).map((header, j, keys) => {
                      let headerValue = '';

                      if (Array.isArray(headers[header][HEADER_CONTENT])) {
                        headerValue = headers[header][HEADER_CONTENT][1](record[headers[header][HEADER_CONTENT][0]]);
                      } else {
                        headerValue = record[headers[header][HEADER_CONTENT]];
                      }

                      return (
                        <Table.Cell key={j}>
                          <Header as="h5">
                            <Header.Content>
                              {headerValue}
                              {
                                headers[header][HEADER_SUBHEADER] &&
                                <Header.Subheader>{record[headers[header][HEADER_SUBHEADER]]}</Header.Subheader>
                              }
                            </Header.Content>
                          </Header>
                        </Table.Cell>
                      );
                    })
                  }
                  <Table.Cell collapsing>
                    <Button
                      style={{ margin: 0 }} size="mini" basic negative icon="trash"
                      onClick={removeRecord.bind(null, record.id)} />
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    );
  }
};

export default RecordTable;


// WEBPACK FOOTER //
// ./client/components/tables/RecordTable.js